import { Paperclip, X } from "lucide-react";
import { useRef } from "react";

import { formatBytes } from "../lib/format";

export function FilePicker({
  files,
  onChange,
  maxBytes = 25 * 1024 * 1024,
  disabled = false,
}: {
  files: File[];
  onChange: (files: File[]) => void;
  maxBytes?: number;
  disabled?: boolean;
}) {
  const inputRef = useRef<HTMLInputElement>(null);

  function addFiles(list: FileList | null) {
    if (!list) return;
    const next = Array.from(list).filter((file) => file.size <= maxBytes);
    const seen = new Set(files.map((file) => `${file.name}:${file.size}:${file.lastModified}`));
    onChange([...files, ...next.filter((file) => !seen.has(`${file.name}:${file.size}:${file.lastModified}`))].slice(0, 10));
  }

  return (
    <div className="file-picker">
      <input
        ref={inputRef}
        className="sr-only"
        type="file"
        multiple
        disabled={disabled}
        onChange={(event) => addFiles(event.currentTarget.files)}
        aria-label="Choose attachments"
      />
      <button className="button button--quiet button--small" type="button" disabled={disabled} onClick={() => inputRef.current?.click()}>
        <Paperclip aria-hidden="true" size={16} /> Attach files
      </button>
      <span className="field-hint">Up to 10 files, {formatBytes(maxBytes)} each</span>
      {files.length > 0 && (
        <ul className="file-list" aria-label="Selected attachments">
          {files.map((file, index) => (
            <li key={`${file.name}:${file.lastModified}`}>
              <span><Paperclip aria-hidden="true" size={14} /> {file.name}</span>
              <small>{formatBytes(file.size)}</small>
              <button type="button" disabled={disabled} onClick={() => onChange(files.filter((_, current) => current !== index))} aria-label={`Remove ${file.name}`}>
                <X aria-hidden="true" size={15} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
